const revenueUnitsModule = {
  namespaced: true,
  state: {
    paramList: {},
    paramListRel: {},
  },

  actions: {
    setParamList({ commit }, paramList) {
      commit('setParamList', paramList);
    },
  },

  mutations: {
    setParamList(state, paramList) {
      state.paramList = { ...paramList };
    },
  },

  getters: {
    gGetParamList(state) {
      return state.paramList;
    },
  },
};
export default revenueUnitsModule;
